import { HotelCity } from './types'

export const defaultHotelCities: HotelCity[] = [
  {
    id: 6433,
    state: {
      id: 100008,
      title: 'تهران',
    },
    title_fa: 'تهران',
    title_en: 'Tehran',
  },
  {
    id: 6497,
    state: {
      id: 100011,
      title: 'خراسان رضوی',
    },
    title_fa: 'مشهد',
    title_en: 'Mashhad',
  },
  {
    id: 6640,
    state: {
      id: 100017,
      title: 'فارس',
    },
    title_fa: 'شیراز',
    title_en: 'Shiraz',
  },
  {
    id: 6918,
    state: {
      id: 100029,
      title: 'هرمزگان',
    },
    title_fa: 'کیش',
    title_en: 'Kish',
  },
  {
    id: 6326,
    state: {
      id: 100004,
      title: 'اصفهان',
    },
    title_fa: 'اصفهان',
    title_en: 'Isfahan',
  },
  {
    id: 6220,
    state: {
      id: 100001,
      title: 'آذربایجان شرقی',
    },
    title_fa: 'تبریز',
    title_en: 'Tabriz',
  },
  {
    id: 6984,
    state: {
      id: 100004,
      title: 'اصفهان',
    },
    title_fa: 'کاشان',
    title_en: 'Kashan',
  },
  {
    id: 6931,
    state: {
      id: 100029,
      title: 'هرمزگان',
    },
    title_fa: 'قشم',
    title_en: 'Qeshm',
  },
]
